export default {
    data(){
     return{
      matches:[],
      id: this.$route.params.id,
      matched_id: this.$route.params.id,
      matched:[],
      matchedScore:[],
      matchedCard:[],
      top_score:[],
      top_assist:[],
      card_info:{}
     }
    },
    methods: {
        getUpcomingMatch(){
            this.$axios.get('no-auth/match/up-comming').then(res => {
                // Process and sort the matches
                this.matches = res.data.data
                    .map(match => {
                        // Add a temporary field for the original date object
                        return { ...match, dateObj: new Date(match.match_date) };
                    })
                    .sort((a, b) => a.dateObj - b.dateObj) // Sort by the original Date object
                    .map(match => {
                        // Format the match_date after sorting
                        const day = String(match.dateObj.getDate()).padStart(2, '0'); // Day with leading zero
                        const month = String(match.dateObj.getMonth() + 1).padStart(2, '0'); // Month with leading zero
                        const year = match.dateObj.getFullYear();
                        const hours = String(match.dateObj.getHours()).padStart(2, '0'); // Hours with leading zero
                        const minutes = String(match.dateObj.getMinutes()).padStart(2, '0'); // Minutes with leading zero
                        // Create the formatted date
                        const formattedDate = `${day}/${month}/${year} ${hours}:${minutes}`;
                        // Return the match with the formatted date
                        return { ...match, match_date: formattedDate };
                    });
        }).catch(() => {
        });
        },
        teamDetail(){
            this.$axios.get('no-auth/team/' + this.id + '/player').then(res=>{
                this.team_detail = res.data.data;
               
            }).catch(()=>{

            }) 
        },
        getTeamDetailID(id){
            this.$router.push({
                name: "team-detail",
                params:{id},
            });
        },

        getMatched(){
            this.$axios.get('no-auth/match/info').then(res => {
                this.matched = res.data.matches;
                this.top_score = res.data.top_scorer;
                this.top_assist = res.data.top_assist;
                this.card_info = res.data.cardInfo;
        }).catch(() => {
        });
        },
        match_detail(id) {
            this.$router.push({
                name: "match-detail",
                params: {
                    id
                },
            });
        },
        getMatchedDetail(){
            this.$axios.get('no-auth/match/'+this.matched_id+'/result').then(res => {
                this.matched = res.data.match;
                this.matchedScore = res.data.matchScore;
                this.matchedCard = res.data.matchCard;
        }).catch(() => {
        });
        },
    },
    computed: {
        sortedMatches() {
            return this.matches
                .map((match) => {
                    // Format the date
                    const dateObj = new Date(match.match_date);
                    const formattedDate = `${dateObj.toLocaleDateString()} ${dateObj
                        .toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' })}`;
                    return { ...match, match_date: formattedDate };
                })
                .sort((a, b) => new Date(a.match_date) - new Date(b.match_date));
        }
    },
    created(){
     this.getUpcomingMatch();
     this.getMatched();
    }

}
